// Centralized configuration with Firebase Remote Config fallbacks
import { getAdSlotFromRC, getPublisherIdFromRC, getRemoteString } from '../remoteConfig';

export const adConfig = {
  publisherId: 'ca-pub-6690779336808264',
  adSlots: {
    ad1: '8057403001',
    ad2: '4429133276',
    ad3: '7590467322',
    ad4: '6337127225',
    ad5: '6337127225',
    ad6: '7590467322',
    ad7: '4429133276',
    ad8: '8057403001',
    ad9: '7590467322',
    ad10: '4429133276', // New slot for Ad8 (300x250 display ad)
  },
};

export const getAdSlot = (adNumber) => {
  const fallback = adConfig.adSlots[`ad${adNumber}`];
  return getAdSlotFromRC(adNumber, fallback);
};

export const getPublisherId = () => {
  return getPublisherIdFromRC(adConfig.publisherId);
};

// Map placements to RC keys and numeric fallbacks
const placementFallbackToAdNumber = {
  right_side_banner: 2,
  leftside_top_block: 4,
  leftside_bottom_block: 7,
  airline_list_ads: 7,
  airport_list_ads: 7,
  footer_banner: 1,
  left_block_main: 2,
  top_small_map: 8,
  bottom_small_map: 9,
  airline_display_ads: 10, // New placement for Ad8 (300x250 display ad)
};

export const getPlacementSlot = (placementName) => {
  const fallbackAdNumber = placementFallbackToAdNumber[placementName];
  if (!fallbackAdNumber) {
    // Unknown placement, fall back to ad1
    return adConfig.adSlots.ad1;
  }
  const fallbackSlot = adConfig.adSlots[`ad${fallbackAdNumber}`];
  // RC key equals placementName exactly (as created in your console)
  return getRemoteString(placementName, fallbackSlot);
};